import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { useModalService } from "./../../../ricos-modals/index.js";
import { DropdownModal } from "./../../../_shared/dropdown-modal/dropdown-modal.js";
import { ListItemSelect } from "./../../../_shared/list-item-select/list-item-select.js";
import { DIVIDER_BUTTONS } from "../../const.js";
import { dividerSizeData } from "../buttons/dividerButtonsData.js";
const DividerSizePanel = ({ toolbarItem, getSelectedSize }) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useModalService();
  const closeModal = () => modalService.closeModal(DIVIDER_BUTTONS.size);
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      onCloseButtonClick: closeModal,
      title: t("ButtonModal_Size_Section"),
      options: dividerSizeData.map(
        ({ dataHook, icon: Icon, iconSmall: IconSmall, text, commandKey }) => /* @__PURE__ */ React.createElement(
          ListItemSelect,
          {
            key: commandKey,
            dataHook,
            prefix: isMobile ? /* @__PURE__ */ React.createElement(Icon, null) : /* @__PURE__ */ React.createElement(IconSmall, null),
            title: t(text),
            selected: commandKey === getSelectedSize(),
            onSelect: () => {
              toolbarItem.commands?.click({ value: commandKey });
              closeModal();
            }
          }
        )
      )
    }
  );
};
var DividerSizePanel_default = DividerSizePanel;
export {
  DividerSizePanel_default as default
};
//# sourceMappingURL=DividerSizePanel.js.map
